/**
 * schemaEnhancer da variação `newsCarousel` do bloco Listing nativo.
 *
 * Adiciona apenas o campo `autoplay` (spec news-listing.md §4) ao schema
 * herdado do Listing — a query/ordenação/limite continuam nativas.
 */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  autoplay: {
    id: 'Autoplay',
    defaultMessage: 'Autoplay',
  },
});

const newsCarouselSchemaEnhancer = ({ schema, formData, intl }: any) => {
  schema.properties.autoplay = {
    title: intl.formatMessage(messages.autoplay),
    type: 'boolean',
    default: false,
  };
  schema.fieldsets[0].fields.push('autoplay');
  return schema;
};

export default newsCarouselSchemaEnhancer;
